<template>
  <div id="app">
    <div class="d-header">{{ title }}</div>
    <progress class="d-progress" :value="progress" max="100"></progress>
    <div class="d-cont">
      <router-view/>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  data () {
    return {
      title: process.env.VUE_APP_TITLE,
      w_size: {
        height: 0,
        width: 0
      }
    }
  },
  created () {
    this.updateEnds()
    this.gotData({ model: 'window_h', data: window.innerHeight})
    this.gotData({ model: 'window_w', data: window.innerWidth})
  },
  methods: {
    ...mapMutations([
      'updateEnds',
      'gotData'
    ])
  },
  computed: {
    progress () {
      return this.getData('progress')
    },
    ...mapGetters([
      'getData'
    ])
  }
}
</script>
